var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWheelchair = function SvgWheelchair(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 7.5L9.72147 11.8288C9.8822 12.7932 10.7166 13.5 11.6943 13.5H14.7639C15.5215 13.5 16.214 13.928 16.5528 14.6056L18.1413 17.7825C18.3509 18.2017 18.8235 18.4191 19.2782 18.3054L20.5 18M14 10.5H10M7 11.2572C5.7785 12.266 5 13.7921 5 15.5C5 18.5376 7.46243 21 10.5 21C12.2079 21 13.7341 20.2215 14.7428 19M11 5C11 6.10457 10.1046 7 9 7C7.89543 7 7 6.10457 7 5C7 3.89543 7.89543 3 9 3C10.1046 3 11 3.89543 11 5Z",
    stroke: "#282828",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgWheelchair;